import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export default function WorkspaceNavigation({ groups, pathname }) {
  const { t } = useLanguage();
  const navRef = useRef(null);
  let selected, group;
  for (const itemGroup of groups) {
    const items = itemGroup.items.flatMap(item => item.subItems || [item]);
    const match = items.find(item => item.path === pathname);
    if (match) { selected = match; group = { ...itemGroup, items }; break; }
  }
  const selectedLabel = selected?.label;
  useEffect(() => {
    const nav = navRef.current;
    const active = nav?.querySelector('[aria-current="page"]');
    if (!nav || !active) return;
    const navBounds = nav.getBoundingClientRect();
    const activeBounds = active.getBoundingClientRect();
    const left = nav.scrollLeft + activeBounds.left - navBounds.left - (nav.clientWidth - activeBounds.width) / 2;
    nav.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
  }, [pathname, selectedLabel]);
  if (!selected || pathname.startsWith('/invoice/')) return null;
  return <div className="bc-module-context">
    <div className="bc-breadcrumb">
      <Link to="/dashboard" aria-label={t('nav.dashboard')}><Home size={15}/></Link><ChevronRight size={13}/>
      {group.label && <><span>{group.label}</span><ChevronRight size={13}/></>}
      <strong>{selected.label}</strong>
    </div>
    {group.items.length > 1 && <nav ref={navRef} aria-label={group.label || t('nav.relatedModules')}>
      {group.items.map(item => <Link key={item.path} to={item.path} aria-current={pathname === item.path ? 'page' : undefined}>{item.label}</Link>)}
    </nav>}
  </div>;
}
